<template>
  <new-edit-page
    :page-title="$t('NewListItem')"
    :submit-button-label="$t('Save')"
    :submit-button-disabled="submitButtonDisabled"
    @submit="newListValue"
    :is-loading="loading"
    one-section-only
  >
    <template v-slot:wholeSection>
      <list-value-form
        :list-value-data="listValueData"
        type="create"
        :characterMaximumLength="characterMaximumLength"
        :input-type="inputType"
      />
    </template>
  </new-edit-page>
</template>

<script>
import { mapActions } from "vuex";
import NewEditPage from "../../../Management/NewEditPage/NewEditPage";
import utils from "@/utils";
import ListValueForm from "@/components/SystemManagement/SystemSettings/ListsSettings/ListItemForm";

export default {
  name: "NewListItem",

  components: {
    ListValueForm,
    NewEditPage
  },

  data() {
    return {
      listValueData: {
        code: "",
        client_code: null,
        libelle: "",
        client_label: null,
        definition: null,
        blocked: false,
        deleted: false,
        index: null /*,
        status: this.status*/
      },
      loading: false,

      selectedList: null
    };
  },

  computed: {
    /**
     * Indicates if the submit button is disabled or not
     * @return {Boolean}
     */
    submitButtonDisabled() {
      return !(
        this.listValueData.code.length <= 32 &&
        this.listValueData.code.length > 0 &&  
        this.listValueData.libelle.length <= 255 &&
        this.listValueData.libelle.length > 0
        );
    },

    /**
     * Indicates the maximum length for the item code
     * @return {Number}
     */
    characterMaximumLength() {
      if (this.selectedList && this.selectedList.code_rules) {
        return this.selectedList.code_rules.character_maximum_length;
      }
    },

    /**
     * Indicates the type of input for the item code
     * @return {String}
     */
    inputType() {
      if (this.selectedList) {
        if (
          this.selectedList.code_rules &&
          this.selectedList.code_rules.data_type === "character varying"
        ) {
          return "text";
        } else {
          return "number";
        }
      }
    }
  },

  mounted() {
    this.fetchListByListName();
  },

  methods: {
    ...mapActions([
      "CREATE_NEW_LIST_ITEM",
      "GET_LIST_OF_LISTS",
      "createCustomListValue"
    ]),

    /**
     * Creates a new list value.
     * If the list if custom the only data to send is the code and the libelle, along with the list ID.
     * Else, the whole object is sent.
     * The methods executed to create the items are different because the endpoints in the BE are different.
     */
    async newListValue() {
      try {
        this.loading = true;
        let listName = this.selectedList.code.replace("l_", "list_");
        let isCustomList = this.$route.params.isCustomList;

        if (isCustomList) {
          await this.createCustomListValue({
            list_id: this.$route.params.list_id,
            code: this.listValueData.code,
            libelle: this.listValueData.libelle,
            index: this.listValueData.index
          });
        } else {
          await this.CREATE_NEW_LIST_ITEM({
            listName: listName,
            listValueData: this.listValueData
          });
        }

        this.$router.back();
      } catch (error) {
        let errorMessage = utils.errorHandler(error);
        if (typeof errorMessage === "string") {
          this.$toasted.global.toast_error(errorMessage);
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Gets the list by its name.
     */
    async fetchListByListName() {
      try {
        let listName = this.$route.params.listName;
        let result = await this.GET_LIST_OF_LISTS();
        let lists = result.data.data;
        let code = listName.replace("list_", "l_");
        this.selectedList = lists.find(list => list.code === code);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/ListsSettings/NewListItem.vue